/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Greeter, GreeterInterface } from "../Greeter";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_greeting",
        type: "string",
      },
      {
        internalType: "address",
        name: "_aavePoolAddr",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "getUser",
    outputs: [
      {
        internalType: "uint256",
        name: "totalCollateralBase",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalDebtBase",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "availableBorrowsBase",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "currentLiquidationThreshold",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "ltv",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "healthFactor",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "greet",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_greeting",
        type: "string",
      },
    ],
    name: "setGreeting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Greeter__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _greeting: string,
    _aavePoolAddr: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Greeter> {
    return super.deploy(
      _greeting,
      _aavePoolAddr,
      overrides || {}
    ) as Promise<Greeter>;
  }
  getDeployTransaction(
    _greeting: string,
    _aavePoolAddr: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _greeting,
      _aavePoolAddr,
      overrides || {}
    );
  }
  attach(address: string): Greeter {
    return super.attach(address) as Greeter;
  }
  connect(signer: Signer): Greeter__factory {
    return super.connect(signer) as Greeter__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GreeterInterface {
    return new utils.Interface(_abi) as GreeterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Greeter {
    return new Contract(address, _abi, signerOrProvider) as Greeter;
  }
}
